import { render, staticRenderFns } from "./ChipOnApproval.vue?vue&type=template&id=31cf3e5e&scoped=true"
import script from "./ChipOnApproval.vue?vue&type=script&lang=js"
export * from "./ChipOnApproval.vue?vue&type=script&lang=js"
import style0 from "./ChipOnApproval.vue?vue&type=style&index=0&id=31cf3e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf3e5e",
  null
  
)

export default component.exports